module.exports = __webpack_public_path__ + "static/media/volume-mute.d0eda4bd.svg";